import type { Text } from 'slate';

import type { EmphasisMdNode, ReadmeInline } from '@ui/MarkdownEditor/types';

export const deserialize = (node: EmphasisMdNode, deeper: (n: EmphasisMdNode) => (ReadmeInline | Text)[]) => {
  const decorator = '_';

  return [{ text: decorator }, ...deeper(node), { text: decorator }];
};
